/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../../components/common/Layout";
const HolidayStore = dynamic(() =>
  import("../../components/UnlayerTemplates/HolidayStore")
);

export default function HolidayStorePage() {
  const meta = {
    title: "Shop curated trends at Qalara wholesale marketplace ",
    description:
      "Global wholesale platform for sourcing curated selection of candle stands, ornaments, cushion covers, and kitchenware to help your customers spread the holiday cheer.",
    keywords:
      "Curated, trends, values, categories, wholesale, bulk, ready-to-ship, custom, fashion, accessories, homedecor, furniture, rugs, kitchen, dining, linen, furnishings, artisanal, organic, sustainable, ecofriendly India, Southeast asia, carving, inlay, basketry, weaving, metal, global, exports, imports, vendors, suppliers",
    url: "/explore/holiday-store/",
  };

  return (
    <Layout meta={meta}>
      <HolidayStore />
    </Layout>
  );
}
